export default __webpack_public_path__ + "static/media/hcl-jigsaw.ed8c9f46.png";